import { lazy } from 'react';
import { Permission, type SkillManifest } from '@brandschutz/shared';
import type { FrontendSkill } from '../_core/registry';

/**
 * Schlanker Skill-Descriptor — wird vom Bootstrap importiert, OHNE den Barrel
 * (ContactListPage, Wizard-Picker, API) eager zu laden. Slot-Renderer sind
 * React.lazy — <SkillSlot> hat pro Eintrag eine eigene Suspense-Boundary,
 * der Code lädt erst, wenn der jeweilige Slot tatsächlich rendert.
 */
const manifest: SkillManifest = {
  key: 'contact-management',
  name: 'Ansprechpartner-Verwaltung',
  description:
    'Personen pro Kunde anlegen und Projekten zuordnen — füllt Slots in Customer-Detail und Project-Sidebar.',
  category: 'core',
  version: '0.1.0',
  requiredPermissions: [Permission.CONTACT_READ],
  enabledByDefault: true,
};

const CustomerContactsTab = lazy(() =>
  import('./CustomerContactsTab').then((m) => ({ default: m.CustomerContactsTab })),
);
const ProjectContactsBox = lazy(() =>
  import('./ProjectContactsBox').then((m) => ({ default: m.ProjectContactsBox })),
);

export const contactManagementSkill: FrontendSkill = {
  manifest,
  slots: {
    'customer-detail.tabs': [
      {
        key: 'contacts-tab',
        order: 10,
        // @ts-expect-error Slot context shape ist dynamic — Caller liefert customerId
        render: CustomerContactsTab,
      },
    ],
    'project-detail.sidebar': [
      {
        key: 'project-contacts',
        // Block „Wer" der Projekt-Sidebar (order ≤ 30, s. ProjectDetailPage).
        order: 20,
        // @ts-expect-error Slot context shape ist dynamic
        render: ProjectContactsBox,
      },
    ],
  },
};
